import React from 'react';
import { ArrowDownIcon, ArrowRightIcon, GlobeIcon, ShieldCheckIcon } from 'lucide-react';
import { trackCheckoutStart } from '../lib/metaPixel';
const CHECKOUT_URL = 'https://astrologuer-ready.impultienda.ar/checkout';
const CHECKOUT_ANCHOR = '#checkout';
interface CtaButtonProps {
  label: string;
  /** 'checkout' opens the payment page; 'scroll' jumps to the checkout button. */
  target?: 'checkout' | 'scroll';
  tone?: 'dark' | 'light';
  showGuarantee?: boolean;
  className?: string;
}
export function CtaButton({
  label,
  target = 'scroll',
  tone = 'dark',
  showGuarantee = false,
  className = ''
}: CtaButtonProps) {
  const isCheckout = target === 'checkout';
  const isDark = tone === 'dark';
  const Arrow = isCheckout ? ArrowRightIcon : ArrowDownIcon;
  return <div className={`flex flex-col items-center ${className}`} data-id="element-1" data-mp="19b1ndznzug4l">
      <a href={isCheckout ? CHECKOUT_URL : CHECKOUT_ANCHOR} onClick={isCheckout ? trackCheckoutStart : undefined} className="group inline-flex w-full max-w-md items-center justify-center gap-2 rounded-full bg-brand-cta px-6 py-4 text-center font-body text-sm font-black uppercase tracking-[0.04em] text-white shadow-lg shadow-brand-cta/30 transition-[transform,background-color,box-shadow] duration-200 ease-out hover:-translate-y-0.5 hover:bg-brand-ctaHover hover:shadow-xl hover:shadow-brand-cta/40 focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-cta/40 sm:px-9 sm:text-base" data-id="element-2" data-mp="19bbddn91gnaa">
        <span data-id="element-3" data-mp="3sxlvat62d52c">{label}</span>
        <Arrow className="h-5 w-5 flex-none" aria-hidden="true" data-id="element-4" data-mp="3swtyxg4n73b0" />
      </a>

      <p className={`mt-4 inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-bold ${isDark ? 'border-brand-cta/40 bg-brand-cta/10 text-white' : 'border-brand-cta/30 bg-brand-cta/10 text-brand-ink'}`} data-id="element-5" data-mp="1ixxaxkvwf1f">
        <GlobeIcon className="h-4 w-4 flex-none text-brand-cta" aria-hidden="true" data-id="element-6" data-mp="biorsz9g2u1i" />
        Secure checkout — you pay in your local currency
      </p>

      {showGuarantee && <p className={`mt-3 inline-flex items-center gap-2 text-sm font-bold ${isDark ? 'text-white/85' : 'text-brand-ink/80'}`} data-id="element-7" data-mp="3myieb5kimi5o">
          <ShieldCheckIcon className="h-4 w-4 flex-none text-brand-lilac" aria-hidden="true" data-id="element-8" data-mp="3hw9lqabk1i43" />
          7-day money-back guarantee
        </p>}
    </div>;
}